import { DataSource, Label, Layout, Panel, Switch, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutCallListProfile extends Layout {
    labelCallListFilters: Label;
    labelCustomersOnly: Label;
    labelN: Label;
    labelNoPenAdingActivity: Label;
    panelCallListFilters: Panel;
    panelCustProsp: Panel;
    panelCustProspOpp: Panel;
    panelNoPendingActivity: Panel;
    panelOverviewFilters: Panel;
    sourceCallListProfile: DataSource;
    switchFilterOpsUser: Switch;
    switchFilterProspectType: Switch;
    switchFilterSalesManager: Switch;
    switchFilterSalesStatus: Switch;
    switchFilterSalesperson: Switch;
    switchIncludeOpportunities: Switch;
    switchIncludeProspects: Switch;
    textboxActDays: Textbox;
    textboxActType: Textbox;
    textboxCustomerId: Textbox;
    textboxDescr: Textbox;
    textboxId: Textbox;
    textboxLastOrderDays: Textbox;
    textboxMinValue: Textbox;
    textboxOperationsUser: Textbox;
    textboxOpportunityId: Textbox;
    textboxProspectTypeId: Textbox;
    textboxRespCode: Textbox;
    textboxRespLevel: Textbox;
    textboxSalesManagerId: Textbox;
    textboxSalespersonId: Textbox;
    textboxStatus: Textbox;
    textboxTypeOf: Textbox;
    textboxZoneId: Textbox;
}
